import { render, staticRenderFns } from "./Midias.vue?vue&type=template&id=6642d0fa&scoped=true"
import script from "./Midias.vue?vue&type=script&lang=js"
export * from "./Midias.vue?vue&type=script&lang=js"
import style0 from "./Midias.vue?vue&type=style&index=0&id=6642d0fa&prod&scoped=true&lang=css"
import style1 from "./Midias.vue?vue&type=style&index=1&id=6642d0fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642d0fa",
  null
  
)

export default component.exports